import { classNames } from '@ember-decorators/component';
import PatternForm from './pattern-form';
import styles from './pattern-form-therapyfinder-embed.module.scss';

@classNames(styles.component)
export default class SharedPatternFormTherapyfinderEmbed extends PatternForm {
  styles = styles;
}
